const productsActionTypes = {
  GET_ALL_PRODUCTS_START: "GET_ALL_PRODUCTS_START",
  GET_ALL_PRODUCTS_SUCCESS: "GET_ALL_PRODUCTS_SUCCESS",
  GET_ALL_PRODUCTS_FAILED: "GET_ALL_PRODUCTS_FAILED",
  GET_PRODUCT_CATEGORY_START: "GET_PRODUCT_CATEGORY_START",
  GET_PRODUCT_CATEGORY_SUCCESS: "GET_PRODUCT_CATEGORY_SUCCESS",
  GET_PRODUCT_CATEGORY_FAILED: "GET_PRODUCT_CATEGORY_FAILED",
  GET_PRODUCT_GROUPS_FAILED: "GET_PRODUCT_GROUPS_FAILED",
  GET_PRODUCT_GROUPS_SUCCESS: "GET_PRODUCT_GROUPS_SUCCESS",
  GET_PRODUCT_GROUPS_START: "GET_PRODUCT_GROUPS_START",
  GET_BRANDS_START: "GET_BRANDS_START",
  GET_BRANDS_SUCCESS: "GET_BRANDS_SUCCESS",
  GET_BRANDS_FAILED: "GET_BRANDS_FAILED",
  GET_SUPPLIERS_START: "GET_SUPPLIERS_START",
  GET_SUPPLIERS_SUCCESS: "GET_SUPPLIERS_SUCCESS",
  GET_SUPPLIERS_FAILED: "GET_SUPPLIERS_FAILED",
  GET_PRODUCT_TOTAL_COUNT_SUCCESS: "GET_PRODUCT_TOTAL_COUNT_SUCCESS",
  GET_PRODUCT_TOTAL_COUNT_FAILED: "GET_PRODUCT_TOTAL_COUNT_FAILED",
  GET_PRODUCT_TOTAL_COUNT_START: "GET_PRODUCT_TOTAL_COUNT_START",
  GET_ASSORTMENTS_START: "GET_ASSORTMENTS_START",
  GET_ASSORTMENTS_SUCCESS: "GET_ASSORTMENTS_SUCCESS",
  GET_ASSORTMENTS_FAILED: "GET_ASSORTMENTS_FAILED",
  GET_VAT_RATES_START: "GET_VAT_RATES_START",
  GET_VAT_RATES_SUCCESS: "GET_VAT_RATES_SUCCESS",
  GET_VAT_RATES_FAILED: "GET_VAT_RATES_FAILED",
  GET_PRODUCT_GROUP_TOTAL_COUNT_SUCCESS:
    "GET_PRODUCT_GROUP_TOTAL_COUNT_SUCCESS",
  GET_PRODUCT_GROUP_TOTAL_COUNT_FAILED: "GET_PRODUCT_GROUP_TOTAL_COUNT_FAILED",
  GET_PRODUCT_GROUP_TOTAL_COUNT_START: "GET_PRODUCT_GROUP_TOTAL_COUNT_START",
  GET_PRIORITY_GROUP_START: "GET_PRIORITY_GROUP_START",
  GET_PRIORITY_GROUP_SUCCESS: "GET_PRIORITY_GROUP_SUCCESS",
  GET_PRIORITY_GROUP_FAILED: "GET_PRIORITY_GROUP_FAILED",
  GET_PRODUCT_COUNTRY_START: "GET_PRODUCT_COUNTRY_START",
  GET_PRODUCT_COUNTRY_SUCCESS: "GET_PRODUCT_COUNTRY_SUCCESS",
  GET_PRODUCT_COUNTRY_FAILED: "GET_PRODUCT_COUNTRY_FAILED",
  GET_COMPANY_TYPES_START: "GET_COMPANY_TYPES_START",
  GET_COMPANY_TYPES_SUCCESS: "GET_COMPANY_TYPES_SUCCESS",
  GET_COMPANY_TYPES_FAILED: "GET_COMPANY_TYPES_FAILED",
  GET_CURRENCIES_START: "GET_CURRENCIES_START",
  GET_CURRENCIES_SUCCESS: "GET_CURRENCIES_SUCCESS",
  GET_CURRENCIES_FAILED: "GET_CURRENCIES_FAILED",
  GET_SUPPLIER_TYPES_START: "GET_SUPPLIER_TYPES_START",
  GET_SUPPLIER_TYPES_SUCCESS: "GET_SUPPLIER_TYPES_SUCCESS",
  GET_SUPPLIER_TYPES_FAILED: "GET_SUPPLIER_TYPES_FAILED",
  GET_INDENTED_GROUPS_START: "GET_INDENTED_GROUPS_START",
  GET_INDENTED_GROUPS_SUCCESS: "GET_INDENTED_GROUPS_SUCCESS",
  GET_INDENTED_GROUPS_FAILED: "GET_INDENTED_GROUPS_FAILED",
  GET_INDENTED_CATEGORY_START: "GET_INDENTED_CATEGORY_START",
  GET_INDENTED_CATEGORY_SUCCESS: "GET_INDENTED_CATEGORY_SUCCESS",
  GET_INDENTED_CATEGORY_FAILED: "GET_INDENTED_CATEGORY_FAILED",
};

export default productsActionTypes;
